import React, {useEffect, useState} from 'react';
import { Accordion } from 'react-bootstrap';
import PackageCard from './PackageCard';
import ChangingLimitModal from '../Modals/ChangingLimitModal';
import ChangingRegionModal from '../Modals/ChangingRegionModal';
import AddPackageModal from '../Modals/AddPackageModal';

const FlowCard = ({ flow, refreshFlows, userData }) => {
  // Переносим состояние модальных окон сюда
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const [showChangingLimitModal, setShowChangingLimitModal] = useState(false);
  const [changingLimitModalData, setChangingLimitModalData] = useState(null);
  const [showChangingRegionModal, setShowChangingRegionModal] = useState(false);
  const [changingRegionModalData, setChangingRegionModalData] = useState(null);
  const [showAddPackageModal, setShowAddPackageModal] = useState(false);

  const closeChangingLimitModal = () => {
    setShowChangingLimitModal(false);
    setChangingLimitModalData(null);
  };

  const closeChangingRegionModal = () => {
    setShowChangingRegionModal(false);
    setChangingRegionModalData(null);
  };

  const closeAddPackageModal = () => {
    setShowAddPackageModal(false);
  };

  const handleAddPackage = () => {
    setShowAddPackageModal(true);
  };

  // Обработчики кликов с передачей данных потока
  const handleLimitClick = (pkg) => {
    setChangingLimitModalData({
      ...pkg,
      flow_guide_id: flow.flow_guide_id,
      flow_guide_name: flow.flow_guide_name,
      integration_id: flow.integration_id
    });
    setShowChangingLimitModal(true);
  };

  const handleRegionClick = (pkg) => {
    setChangingRegionModalData({
      ...pkg,
      flow_guide_id: flow.flow_guide_id,
      flow_guide_name: flow.flow_guide_name,
      integration_id: flow.integration_id
    });
    setShowChangingRegionModal(true);
  };
  const countLeadsMonth = flow.pakets[0] ? flow.pakets[1] ? flow.pakets[0].leads_current_month.length + flow.pakets[1].leads_current_month.length
      : flow.pakets[0].leads_current_month.length
      : flow.pakets[1] ? flow.pakets[1].leads_current_month.length
      : 0;

  const countLeadsAllTime = flow.pakets[0] ? flow.pakets[1] ? flow.pakets[0].leads + flow.pakets[1].leads
      : flow.pakets[0].leads
      : flow.pakets[1] ? flow.pakets[1].leads
      : 0;
  console.log("flow: ", flow);
  return (
    <Accordion className="flow-card-container">
      <Accordion.Item eventKey="0">
        <Accordion.Header className="flow-card-main">
          {!isMobile && (
              <div className="flow-left-content">
                <div className="flow-content-block">
                  <span className="flow-content-number">{countLeadsAllTime || '0'}</span>
                  <span className="flow-content-label">за все время</span>
                </div>
              </div>
          )}

          {!isMobile && (
              <div className="flow-middle-content">
                <div className="flow-content-block">
                  <span className="flow-content-number-middle">{countLeadsMonth || '0'}</span>
                  <span
                      className="flow-content-label-middle">за {new Date().toLocaleDateString('ru-RU', {month: 'long'})}</span>
                </div>
              </div>
          )}

          <div className="flow-right-content">
            <div className="flow-right-header">
              <h3 className="flow-card-title">{flow.flow_guide_name}</h3>
              {/*<span className="flow-card-title-second">{new Date(flow.created_at).toLocaleDateString('ru-RU')}</span>*/}
            </div>
            {!isMobile && (
                <p className="flow-card-description">{flow.text}</p>
            )}

          </div>
        </Accordion.Header>

        <Accordion.Body className="flow-card-expanded-content">
          <div className="package-cards-container">
            {flow.pakets && flow.pakets.map((pkg, index) => (
              <div key={index} className="package-cards-item" style={{ width: (100/flow.pakets.length)+'%' }}>
                <PackageCard 
                  packageData={pkg}
                  onLimitClick={() => handleLimitClick(pkg)}
                  onRegionClick={() => handleRegionClick(pkg)}
                />
              </div>
            ))}
            {flow.pakets.length < 2 && (
              <div className="btn btn-primary package-cards-add-btn" onClick={handleAddPackage}>
                <div className="package-add-icon">+</div>
              </div>
            )}
          </div>
        </Accordion.Body>
      </Accordion.Item>

      {/* Рендерим модальные окна внутри FlowCard */}
      {showChangingLimitModal && (
        <ChangingLimitModal
          isOpen={showChangingLimitModal}
          onClose={closeChangingLimitModal}
          packageData={changingLimitModalData}
          refreshFlows={refreshFlows}
        />
      )}

      {showChangingRegionModal && (
        <ChangingRegionModal
          isOpen={showChangingRegionModal}
          onClose={closeChangingRegionModal}
          packageData={changingRegionModalData}
          refreshFlows={refreshFlows}
        />
      )}

      {showAddPackageModal && (
        <AddPackageModal
          isOpen={showAddPackageModal}
          onClose={closeAddPackageModal}
          onPackageCreated={refreshFlows}
          flowData={flow}
          userData={userData}
        />
      )}
    </Accordion>
  );
};

export default FlowCard;
